import PopoverProvider from 'components/popover/providers/PopoverProvider'
import { FC } from 'react'
import { PopoverContainer } from './Styles'

type PopoverProps = {
  triggerMode?: 'click' | 'hover'
}

const Popover: FC<PopoverProps> = ({ children, triggerMode }) => (
  <PopoverProvider triggerMode={triggerMode}>
    <PopoverContainer>{children}</PopoverContainer>
  </PopoverProvider>
)

export default Popover
